export enum EnumRedondeo {
  UnDecimal = 1,
  DosDecimales = 2,
  TresDecimales = 3,
  CuatroDecimales = 4,
  CincoDecimales = 5,
  SeisDecimales = 6,
  SieteDecimal = 7,
  OchoDecimales = 8,
  NueveDecimales = 9,
  DiezDecimales = 10,
  OnceDecimales = 11,
  DoceDecimales = 12

}
